import { Button, Divider, Modal } from "antd-mobile";
import { CloseOutline } from 'antd-mobile-icons'

export const isAlphaNum = (inputString) => {
    // Regular expression to match alphanumeric characters
    var alphanumericRegex = /^[a-zA-Z0-9-]+$/;
    // Test if the input string matches the alphanumeric pattern
    return alphanumericRegex.test(inputString);
}

export const monthsOld = (_timestamp) => {
    // Calculate the age of the timestamp in months
    const timestampMilliseconds = _timestamp * 1000;
    const currentDate = new Date();
    const timestampDate = new Date(timestampMilliseconds);
    const monthsDiff = (currentDate.getFullYear() - timestampDate.getFullYear()) * 12 + (currentDate.getMonth() - timestampDate.getMonth());
    return monthsDiff;
}

export const drawPrice = (_num, _from_int = false) => {
  if (isNaN(parseInt(_num))) {
    return "";
  } else {
    if(_from_int){
      _num = _num/100;
    }
    return Number(_num).toFixed(2);
  }
}

export const drawError = (_message, _button = "Close", _callback = () => { }, _title = "Error", _can_close = true) => {

    const handler = Modal.show({
        title: <div>{_title} {(_can_close && <div style={{"position" : "absolute", "right" : "15px", "top" : "10px", "cursor" : "pointer"}} onClick={() => handler.close()}><CloseOutline /></div>)} <br /></div>,
        content: (
            <div style={{ "textAlign": "center", "maxWidth": "260px" }}>{_message}<br /><br />
                {(_button && <Button danger block onClick={() => { handler.close(); _callback(); }}>{_button}</Button>)}
            </div>
        ),
        closeOnMaskClick: (_button),
    });
}